__webpack_require__.p = "https://www.nespresso.com/";